/* ver 1.02 */

import * as THREE from "three";

export function Input(unify) {
  let mouseDownCallbacks = [];
  let mouseUpCallbacks = [];
  let mouseWheelCallbacks = [];
  let mouseDownCallbackButtons = [];
  let mouseUpCallbackButtons = [];
  let pressedKeys = [];
  let onKeyDownCallbacks = [];
  let onKeyDownCallbackKeys = [];
  let onKeyUpCallbacks = [];
  let onKeyUpCallbackKeys = [];
  // =====================
  // MOUSE Event Listeners
  window.addEventListener(
    "mousemove",
    function(e) {
      onMouseMove(e);
    }.bind(this),
    false
  );
  window.addEventListener(
    "mousedown",
    function(e) {
      onMouseDown(e);
    }.bind(this),
    false
  );
  window.addEventListener(
    "mouseup",
    function(e) {
      onMouseUp(e);
    }.bind(this),
    false
  );
  window.addEventListener(
    "wheel",
    function(e) {
      onMouseWheel(e);
    }.bind(this),
    false
  );
  window.addEventListener(
    "keydown",
    function(e) {
      onKeyDown(e);
    }.bind(this),
    false
  );
  window.addEventListener(
    "keyup",
    function(e) {
      onKeyUp(e);
    }.bind(this),
    false
  );
  // =======
  // Mouse
  let mousePosition = new THREE.Vector2();
  let mouseButton = {
    left: false,
    middle: false,
    right: false
  };

  // --------------------------------------------------------
  // Event Handlers
  // --------------------------------------------------------
  const onMouseMove = event => {
    // calculate mouse position in normalized device coordinates
    // (-1 to +1) for both components
    mousePosition.x = (event.clientX / window.innerWidth) * 2 - 1;
    mousePosition.y = -(event.clientY / window.innerHeight) * 2 + 1;
  };
  const onMouseDown = event => {
    if (event.button == 0) {
      mouseButton.left = true;
    }
    if (event.button == 1) {
      mouseButton.middle = true;
    }
    if (event.button == 2) {
      mouseButton.right = true;
    }
    for (let i = 0; i < mouseDownCallbacks.length; i++) {
      if (mouseDownCallbackButtons[i] == -1) {
        mouseDownCallbacks[i](event);
      } else {
        if (event.button == mouseDownCallbackButtons[i]) {
          mouseDownCallbacks[i](event);
        }
      }
    }
  };
  const onMouseUp = event => {
    if (event.button == 0) {
      mouseButton.left = false;
    }
    if (event.button == 1) {
      mouseButton.middle = false;
    }
    if (event.button == 2) {
      mouseButton.right = false;
    }

    for (let i = 0; i < mouseUpCallbacks.length; i++) {
      if (mouseUpCallbackButtons[i] == -1) mouseUpCallbacks[i](event);
      else {
        if (event.button == mouseUpCallbackButtons[i])
          mouseUpCallbacks[i](event);
      }
    }
  };
  const onMouseWheel = event => {
    for (let i = 0; i < mouseWheelCallbacks.length; i++) {
      mouseWheelCallbacks[i](event.deltaY);
    }
  };

  const onKeyDown = event => {
    // add key to array
    if (!pressedKeys.includes(event.key)) {
      pressedKeys.push(event.key);
    }
    // fire keyDown callbacks
    for (let i = 0; i < onKeyDownCallbacks.length; i++) {
      if (onKeyDownCallbackKeys[i] == "") onKeyDownCallbacks[i](event);
      else {
        if (event.key == onKeyDownCallbackKeys[i]) onKeyDownCallbacks[i](event);
      }
    }
  };
  const onKeyUp = event => {
    // remove key from array
    for (let i = 0; i < pressedKeys.length; i++) {
      if (pressedKeys[i] == event.key) pressedKeys.splice(i, 1);
    }
    // fire keyUp callbacks
    for (let i = 0; i < onKeyUpCallbacks.length; i++) {
      if (onKeyUpCallbackKeys[i] == "") onKeyUpCallbacks[i](event);
      else {
        if (event.key == onKeyUpCallbackKeys[i]) onKeyUpCallbacks[i](event);
      }
    }
  };

  // --------------------------------------------------------
  // Public Interface
  // --------------------------------------------------------
  this.keyIsPressed = key => {
    return pressedKeys.includes(key);
  };
  this.getPressedKeys = () => {
    return pressedKeys;
  };
  this.getMousePosition = () => {
    return mousePosition;
  };
  this.getMouseButton = () => {
    return mouseButton;
  };

  // callbacks
  this.addMouseDown = (func, button) => {
    mouseDownCallbacks.push(func);
    if (button == 0 || button == "left") mouseDownCallbackButtons.push(0);
    else if (button == 1 || button == "middle")
      mouseDownCallbackButtons.push(1);
    else if (button == 2 || button == "right") mouseDownCallbackButtons.push(2);
    else mouseDownCallbackButtons.push(-1);
  };
  this.addMouseUp = (func, button) => {
    mouseUpCallbacks.push(func);
    if (button == 0 || button == "left") mouseUpCallbackButtons.push(0);
    else if (button == 1 || button == "middle") mouseUpCallbackButtons.push(1);
    else if (button == 2 || button == "right") mouseUpCallbackButtons.push(2);
    else mouseUpCallbackButtons.push(-1);
  };
  this.removeMouseDown = func => {
    for (let i = 0; i < mouseDownCallbacks.length; i++) {
      if (mouseDownCallbacks[i] === func) {
        mouseDownCallbacks.splice(i, 1);
        mouseDownCallbackButtons.splice(i, 1);
      }
    }
  };
  this.removeMouseUp = func => {
    for (let i = 0; i < mouseUpCallbacks.length; i++) {
      if (mouseUpCallbacks[i] === func) {
        mouseUpCallbacks.splice(i, 1);
        mouseUpCallbackButtons.splice(i, 1);
      }
    }
  };
  this.addMouseWheel = func => {
    mouseWheelCallbacks.push(func);
  };
  this.addKeyDown = (func, key) => {
    onKeyDownCallbacks.push(func);
    if (typeof key == "undefined") onKeyDownCallbackKeys.push("");
    else onKeyDownCallbackKeys.push(key);
  };
  this.addKeyUp = (func, key) => {
    onKeyUpCallbacks.push(func);
    if (typeof key == "undefined") onKeyUpCallbackKeys.push("");
    else onKeyUpCallbackKeys.push(key);
  };
  this.removeKeyDown = func => {
    for (let i = 0; i < onKeyDownCallbacks.length; i++) {
      if (onKeyDownCallbacks[i] === func) {
        onKeyDownCallbacks.splice(i, 1);
        onKeyDownCallbackKeys.splice(i, 1);
      }
    }
  };
  this.removeKeyUp = func => {
    for (let i = 0; i < onKeyUpCallbacks.length; i++) {
      if (onKeyUpCallbacks[i] === func) {
        onKeyUpCallbacks.splice(i, 1);
        onKeyUpCallbackKeys.splice(i, 1);
      }
    }
  };

  // --------------------------------------------------------
  // Helper functions
  // --------------------------------------------------------

  // Screen coords to world coords at Z [not yet implemented or tested]
  this.screenToWorldPosition = (vec2, zPos) => {
    var vector = new THREE.Vector3(vec2.x, vec2.y, zPos);
    vector.unproject(unify.camera);
    var dir = vector.sub(unify.camera.position).normalize();
    var distance = -unify.camera.position.z / dir.z;
    var worldPos = unify.camera.position
      .clone()
      .add(dir.multiplyScalar(distance));
    return worldPos;
  };

  //this.earlyUpdate = deltaTime => {}
}
